import { render, staticRenderFns } from "./CheckinRuleAdd.vue?vue&type=template&id=47491735&scoped=true"
import script from "./CheckinRuleAdd.vue?vue&type=script&lang=js"
export * from "./CheckinRuleAdd.vue?vue&type=script&lang=js"
import style0 from "./CheckinRuleAdd.vue?vue&type=style&index=0&id=47491735&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47491735",
  null
  
)

export default component.exports